import { findClosestValueInTimeSeries, roundWeatherValue } from 'app/helpers/weatherProcessSchemaUtils';
import { NoiseEvent } from 'app/business-logic/services/noise-service';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { NoiseEventTableData } from './EventsListing.types';
import { useEventHistoryWeatherData } from './useEventHistoryWeatherData';

export const useEventHistoryTableData = ({ data }: { data: NoiseEvent[] | undefined }) => {
  const { getWeatherDataForLocationId } = useEventHistoryWeatherData({
    data,
  });
  const tableData: NoiseEventTableData[] = useMemo(() => {
    return (
      data?.map(event => {
        const targetMillis = DateTime.fromISO(event.startTime ?? '').toMillis();
        const weatherData = getWeatherDataForLocationId(event.locationId);
        return {
          ...event,
          windSpeed: {
            value: roundWeatherValue(findClosestValueInTimeSeries(weatherData?.windSpeed.data, targetMillis)),
            displayUnit: weatherData?.windSpeed.displayUnit,
          },
          windDirection: {
            value: roundWeatherValue(findClosestValueInTimeSeries(weatherData?.windDirection.data, targetMillis)),
            displayUnit: weatherData?.windDirection.displayUnit,
          },
          rainfall: {
            value: roundWeatherValue(findClosestValueInTimeSeries(weatherData?.rainfall.data, targetMillis)),
            displayUnit: weatherData?.rainfall.displayUnit,
          },
        };
      }) ?? []
    );
  }, [data, getWeatherDataForLocationId]);
  return {
    tableData,
  };
};
